<empty-layout *ngIf="layout === 'empty'"></empty-layout>
